import { useLocale } from "../i18n";
import "./auth-channels.css";

export function AuthChannelChoice({ email, onPhone, onEmail, disabled }: {
  email: boolean; onPhone: () => void; onEmail: () => void; disabled: boolean;
}) {
  const { w } = useLocale();
  return <div className="auth-channel-choice" role="group" aria-label={w("طريقة التحقق", "Verification method")}>
    <button type="button" aria-pressed={!email} disabled={disabled} onClick={onPhone}>{w("رقم الهاتف", "Phone number")}</button>
    <button type="button" aria-pressed={email} disabled={disabled} onClick={onEmail}>{w("البريد الإلكتروني", "Email")}</button>
  </div>;
}
